import { render, staticRenderFns } from "./InventoryMaintenance.vue?vue&type=template&id=b84996a8&scoped=true&lang=true"
import script from "./InventoryMaintenance.vue?vue&type=script&lang=js"
export * from "./InventoryMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84996a8",
  null
  
)

export default component.exports